import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { PLATFORM_GROUPS, TENANT_GROUPS, firstVisibleItem } from '../config/navigation';

/**
 * What `/` renders: the Dashboard, for anyone whose role has it.
 *
 * Anyone whose role does not is sent to the first page their sidebar offers -
 * the same rule the Not Allowed page uses to find a way out. Nothing here
 * knows about particular pages: a Vertical with a review queue lands on it
 * because it is their first entry, and one with nothing assigned yet lands on
 * whatever comes next rather than on a Dashboard they cannot open.
 *
 * Login always goes to `/`, so this is also where each role's home is decided.
 */
const LandingRoute: React.FC<{ dashboard: React.ReactElement }> = ({ dashboard }) => {
  const { user, can, hasFeature, hasMenuPermission } = useAuth();
  if (hasMenuPermission('dashboard')) return dashboard;

  const ctx = { can, hasFeature, hasMenuPermission, planExempt: !!user?.noPlanNeed };
  const first = firstVisibleItem(can('platform.admin') ? PLATFORM_GROUPS : TENANT_GROUPS, ctx);
  // A role that opens no page at all still has its own profile.
  return <Navigate to={first && first.path !== '/' ? first.path : '/profile'} replace />;
};

export default LandingRoute;
